export default "__VITE_ASSET__nxT1UpMV__"